import { render } from "./ApiLimitsEditor.vue?vue&type=template&id=6281c794&scoped=true"
import script from "./ApiLimitsEditor.vue?vue&type=script&lang=js"
export * from "./ApiLimitsEditor.vue?vue&type=script&lang=js"

import "./ApiLimitsEditor.vue?vue&type=style&index=0&id=6281c794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6281c794"]])

export default __exports__